import React, { useState, useEffect } from 'react';
import { 
  Card, 
  Row, 
  Col, 
  Statistic, 
  Typography, 
  Table,
  Tag,
  Progress,
  Badge,
  Space
} from 'antd';
import {
  ShoppingOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  PieChartOutlined,
  ExclamationCircleOutlined,
  FireOutlined,
  HistoryOutlined
} from '@ant-design/icons';
import { FaPizzaSlice, FaHamburger, FaCoffee, FaIceCream, FaWineGlassAlt } from 'react-icons/fa';
import Api from '../api/Api';
import formatarValor from '../formatarValor';

const { Title, Text } = Typography;

const DashboardRestaurante = () => {
  const [produtosMaisPedidos, setprodutosMaisPedidos] = useState([]);
  const [ultimosPedidos, setultimosPedidos] = useState([]);
  const [pedidosData, setpedidosData] = useState([]);
  const [TotalPedido, setTotalPedido] = useState(0);
  const [Totalaberto, setTotalaberto] = useState(0);
  const [TotalFechado, setTotalFechado] = useState(0);
  const [TotalCancelado, setTotalCancelado] = useState(0);

  const [TotalProduto, setTotalProduto] = useState(0);
  const [semEstoque, setsemEstoque] = useState(0);
  const [Disponivel, setDisponivel] = useState(0);
  const [Indisponivel, setIndisponivel] = useState(0);
   
 

  // Dados para os cards de produtos
 

  useEffect(() => {
    fetchMaisVendidos();
    fetchUltimosPedidos();
    fetchDashboard();
  }, []);

    useEffect(() => {
     document.title = "Dashboard";
   
  }, []);

 

  const fetchMaisVendidos = async () => {
    try {
      const response = await Api.MaisVendidos();
      if (Array.isArray(response)) {
        const formatado = response.map(item => ({
          nome: item.descricao,
          key: item.id,
          categoria: item.categoria,
          pedidos: item.total_pedida,
     
        }));
       setprodutosMaisPedidos(formatado);
      } else {
       // sms_error('Formato de resposta inválido');
      }
    } catch (error) {
    //  sms_error('Erro ao buscar hospitais: ' + error.message);
    }
  };


  const fetchDashboard = async () => {
    try {

 
      const response = await Api.DasboardPedido();
      if (response && typeof response === "object") {
        setTotalPedido(response.pedidos || 0);
        setTotalaberto(response.aberto || 0);
        setTotalFechado(response.fechado || 0);
        setTotalCancelado(response.cancelado || 0);
        setIndisponivel(response.indidisponivel || 0);
        setDisponivel(response.disponivel || 0);
        setTotalProduto(response.produto || 0);
         setsemEstoque(response.semEstoque || 0);

        
    } else {
       // toast.error("Erro ao carregar os dados do dashboard.");
    }
      
    } catch (error) {
     // toast.error("Erro ao buscar mensagens: " + (error.response?.data?.message || error.message));
    }
  };



 



    const fetchUltimosPedidos = async () => {
    try {
      const response = await Api.UltimosPedidos();
      if (Array.isArray(response)) {
        const formatado = response.map(item => ({
      produto:  item.produto,
      qtd: item.quantidade,
      mesa: item.mesa,
      status: item.status,
      statusText: item.status,
      total:item.total, 
      valor: item.preco
     
        }));
       setultimosPedidos(formatado);
      } else {
       // sms_error('Formato de resposta inválido');
      }
    } catch (error) {
    //  sms_error('Erro ao buscar hospitais: ' + error.message);
    }
  };





const colunasPedidos = [
  
    {
      title: 'Mesa',
      dataIndex: 'mesa',
      key: 'mesa'
    },

    {
      title: 'Produto',
      dataIndex: 'produto',
      key: 'produto'
    },
    
    {
      title: 'Qtd',
      dataIndex: 'qtd',
      key: 'qtd'
    },
    {
      title: 'Valor',
      dataIndex: 'valor',
      key: 'valor',

  render: (_, record) => {
    const valor = Number(record.valor ?? 0);
    return ` ${formatarValor(valor)}`;
  },




   //   render: (text) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
      align: 'right'
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      
  render: (_, record) => {
    const total = Number(record.total ?? 0);
    return ` ${formatarValor(total)}`;
  },

      align: 'right'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
       align: 'right',
      render: (status, record) => (
        <Tag color={statusColors[status]}>{record.statusText}</Tag>
      )
      
    },
  ];


 

  // Dados para a tabela de últimos pedidos


  // Configuração de cores para os status
 
  const statusColors = {
    ABERTO: 'blue',
    PENDENTE: 'orange',
    FECHADO: 'green',
    CANCELADO: 'red',
     
  };

  // Colunas para a tabela de produtos mais pedidos
  const colunasProdutos = [
    {
      title: 'Produto',
      dataIndex: 'nome',
      key: 'nome',
      render: (text, record) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: 12, fontSize: '16px' }}>{record.icone}</span>
          <div>
            <div style={{ fontWeight: 'bold' }}>{text}</div>
            <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{record.categoria}</div>
          </div>
        </div>
      ),
    },
    {
      title: 'Pedidos',
      dataIndex: 'pedidos',
      key: 'pedidos',
      render: (text) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
      align: 'right'
    }
  ];

  // Colunas para a tabela de últimos pedidos
  

  return (
    <div style={{ padding: '24px', background: '#f5f5f5', minHeight: '100vh' }}>
      {/* Cabeçalho */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ color: '#1a1a2e', marginBottom: 0 }}>Dashboard Restaurante</Title>
        <Text type="secondary">Visão geral do desempenho do restaurante</Text>
      </div>

      {/* Cards de Pedidos */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card 
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              background: 'linear-gradient(135deg, #ff6b6b 0%, #ff9e6b 100%)',
              color: 'white'
            }}
          >
            <Statistic
              title="Total de Pedidos"
              value={TotalPedido}
              valueStyle={{ color: 'white' }}
              prefix={<ShoppingOutlined />}
            />
            <Progress 
              percent={100} 
              showInfo={false} 
              strokeColor="rgba(255,255,255,0.4)"
              trailColor="rgba(255,255,255,0.2)"
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card 
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              background: 'linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)',
              color: 'white'
            }}
          >
            <Statistic
              title="Pedidos Abertos"
              value={Totalaberto}
              valueStyle={{ color: 'white' }}
              prefix={<ClockCircleOutlined />}
            />
            <Progress 
              percent={(Totalaberto / TotalPedido) * 100} 
              showInfo={false} 
              strokeColor="rgba(255,255,255,0.4)"
              trailColor="rgba(255,255,255,0.2)"
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card 
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              background: 'linear-gradient(135deg, #f5567b 0%, #fd746c 100%)',
              color: 'white'
            }}
          >
            <Statistic
              title="Pedidos Cancelados"
              value={TotalCancelado}
              valueStyle={{ color: 'white' }}
              prefix={<CloseCircleOutlined />}
            />
            <Progress 
              percent={(TotalCancelado / TotalPedido) * 100} 
              showInfo={false} 
              strokeColor="rgba(255,255,255,0.4)"
              trailColor="rgba(255,255,255,0.2)"
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card 
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              background: 'linear-gradient(135deg, #56ab2f 0%, #a8e063 100%)',
              color: 'white'
            }}
          >
            <Statistic
              title="Pedidos Fechados"
              value={TotalFechado}
              valueStyle={{ color: 'white' }}
              prefix={<CheckCircleOutlined />}
            />
            <Progress 
              percent={(TotalFechado / TotalPedido) * 100} 
              showInfo={false} 
              strokeColor="rgba(255,255,255,0.4)"
              trailColor="rgba(255,255,255,0.2)"
            />
          </Card>
        </Col>
      </Row>

      {/* Cards de Produtos */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card 
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            }}
          >
            <Statistic
              title="Total de Produtos"
              value={TotalProduto}
              valueStyle={{ color: '#1a1a2e' }}
              prefix={<PieChartOutlined />}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card 
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            }}
          >
            <Statistic
              title="Sem Estoque"
              value={semEstoque}
              valueStyle={{ color: '#f5222d' }}
              prefix={<ExclamationCircleOutlined />}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card 
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            }}
          >
            <Statistic
              title="Disponíveis"
              value={Disponivel}
              valueStyle={{ color: '#52c41a' }}
              prefix={<CheckCircleOutlined />}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card 
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            }}
          >
            <Statistic
              title="Indisponíveis"
              value={Indisponivel}
              valueStyle={{ color: '#faad14' }}
              prefix={<CloseCircleOutlined />}
            />
          </Card>
        </Col>
      </Row>

      {/* Tabelas de Produtos Mais Pedidos e Últimos Pedidos */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            title={
              <Space>
                <FireOutlined style={{ color: '#ff6b6b' }} />
                <Text strong>Produtos Mais Pedidos</Text>
              </Space>
            }
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              height: '100%'
            }}
          >
            <Table
              dataSource={produtosMaisPedidos}
              columns={colunasProdutos}
              pagination={false}
              size="middle"
            />
          </Card>
        </Col>
        
        <Col xs={24} lg={12}>
          <Card
            title={
              <Space>
                <HistoryOutlined style={{ color: '#ff6b6b' }} />
                <Text strong>Últimos Pedidos</Text>
                <Badge count={5} style={{ backgroundColor: '#ff6b6b' }} />
              </Space>
            }
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              height: '100%'
            }}
          >
            <Table
              dataSource={ultimosPedidos}
              columns={colunasPedidos}
              pagination={false}
              size="middle"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardRestaurante;
